// import 'bootstrap';
// import 'mdbootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdbootstrap/css/mdb.min.css';
global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as teacher from '../libs/tech.teacher'
import * as phone from '../libs/tech.phone'
import * as captchaV3 from '../libs/tech.captchaV3'
//more imports here

$(function () {
    lazyLoad.initLazyLoad('.lazyBackground');
})

export {
    core, teacher, phone, captchaV3
}